import {storage} from "@/utils";
import {token} from "@/api/auth/oauth";

import personIcon from '@/assets/person-icon.png';
import {GREAT_NAMES} from "@/store/modules/great";

const initializeState = {
    uid: '',
    username: '',
    avatar: personIcon,
    mobile: null,
    access_token: null,
    refresh_token: null,
    authorities: [],
    is_login: false,
    remember_me: false
};

const user = {
    state: {
        ...Object.assign({}, initializeState, storage.getSession('user'))
    },
    getters: {
        uid: state => state.uid,
        username: state => state.username,
        avatar: state => state.avatar || personIcon,
        mobile: state => state.mobile,
        access_token: state => state.access_token,
        refresh_token: state => state.refresh_token,
        authorities: state => state.authorities,
        is_login: state => state.is_login,
        remember_me: state => state.remember_me
    },
    mutations: {
        SET_USER: (state, user) => {
            let {uid, name, username, avatar, mobile, access_token, token_type, refresh_token, authorities} = user;
            state.uid = uid;
            state.username = name || username;
            state.avatar = avatar || personIcon;
            state.mobile = mobile;
            state.access_token = `${token_type} ${access_token}`;
            state.refresh_token = refresh_token;
            state.authorities = authorities;
        },
        SET_IS_LOGIN: (state, login) => {
            state.is_login = login;
        },
        SET_REMEMBER_ME: (state, remember_me) => {
            state.remember_me = remember_me;
        }
    },
    actions: {
        async login({commit, state, dispatch}, user) {
            commit('SET_USER', user);
            commit('SET_IS_LOGIN', true);
            storage.setSession('user', state);

            await dispatch(GREAT_NAMES.actions.loadIdols);
            await dispatch(GREAT_NAMES.actions.loadFavorites);
        },
        async rememberMe({state, commit, dispatch}) {
            commit('SET_IS_LOGIN', false);
            try {
                await dispatch('login', await token({grant_type: 'refresh_token', refresh_token: state.refresh_token}));
            } catch (e) {
                await dispatch('logout');
            }
        },
        async logout() {
            storage.removeSession('user');
            location.href = '/'
        }
    }
};

export default user;
